import React, { useEffect } from "react";
import Emitter from "../../helpers/emitters";
import { useContainerDesktopAnimation } from "../../hooks/animation/useContainerDesktopAnimation";
import { useUiRedux } from "../../hooks/useUiRedux";
import { ContainerDesktop } from "./ContainerDesktop";
import { ContainerMobile } from "./ContainerMobile";

export const ContainerCard = () => {
	const { container } = useContainerDesktopAnimation();
	const { state, selectMenuOption, backMenu, goMoveLocation, activeModalCard, activeLoading } = useUiRedux();
	const propsContainer = {
		iconHeader: state.iconHeaderContainer,
		optionSelect: state.selectLocationId,
		selectMenu: state.menuSelect,
		cardLocationMenu: state.cardMenuSelect,
		nameselect: state.nameHeaderCardContainer,
		backMenu: backMenu,
		actionOptionMenu: selectMenuOption,
		actionMoveLocation: goMoveLocation,
		actionModalInformation: activeModalCard,
		loading: state.loading,
	};

	useEffect(() => {
		Emitter.on("onLoadingButton", (data) => {
			activeLoading(data);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<div ref={container} className="absolute xsm:w-full xsm:bottom-0 lg:w-auto z-10 lg:right-16 lg:top-24">
				<div className="xsm:hidden lg:block">
					<ContainerDesktop {...propsContainer} />
				</div>
				<div className="lg:hidden">
					<ContainerMobile {...propsContainer} />
				</div>
			</div>
		</>
	);
};
